<template>
    <a-row :gutter="20">
      <a-col :span="12">
        <base-dict-list @onSelect="onSelect"></base-dict-list>
      </a-col>
      <a-col :span="12">
        <base-dict-item-list :dict="dictRecord"></base-dict-item-list>
      </a-col>
    </a-row>
</template>

<script>
  import BaseDictList from './BaseDictList'
  import BaseDictItemList from './BaseDictItemList'
  export default {
    name: 'List',
    components: { BaseDictItemList, BaseDictList },
    data(){
      return{
        dictRecord:{}
      }
    },
    mounted(){

    },
    methods:{
      onSelect(record){
        this.dictRecord = record
      }
    }
  }
</script>

<style scoped>

</style>